import type { EditorTool } from '../../../types';

export interface DrawingState {
  isDrawing: boolean;
  startX: number;
  startY: number;
  currentX: number;
  currentY: number;
  controlX?: number;
  controlY?: number;
  tool: 'rectangle' | 'circle' | 'triangle' | 'curve' | null;
}

export type BoxDrawingTool = 'rectangle' | 'circle' | 'triangle';

export const INITIAL_DRAWING_STATE: DrawingState = {
  isDrawing: false,
  startX: 0,
  startY: 0,
  currentX: 0,
  currentY: 0,
  tool: null,
};

export function isBoxDrawingTool(tool: EditorTool | null | undefined): tool is BoxDrawingTool {
  return tool === 'rectangle' || tool === 'circle' || tool === 'triangle';
}

export function isShapeDrawingTool(
  tool: EditorTool | null | undefined
): tool is NonNullable<DrawingState['tool']> {
  return isBoxDrawingTool(tool) || tool === 'curve';
}

export function isPlacementOrDrawingTool(tool: EditorTool): boolean {
  return (
    tool === 'text' ||
    tool === 'line' ||
    tool === 'rectangle' ||
    tool === 'circle' ||
    tool === 'triangle' ||
    tool === 'curve' ||
    tool === 'polygon'
  );
}
